export const iconDefinitions: { [key: string]: string } = {
  AdminGroup: '/assets/svg/person.svg',
  Admingroup: '/assets/svg/diversity.svg',
  Organization: '/assets/svg/language.svg',
  Spacegroup: '/assets/svg/folder_open.svg',
  Metergroup: '/assets/svg/folder_open.svg',
  Site: '/assets/svg/builder.svg',
  Meter: '/assets/svg/energy.svg',
  Operator: '/assets/svg/operator.svg',
  Program: '/assets/svg/list_alt.svg',
  Product: '/assets/svg/inventory.svg',
  Portfolio: '/assets/svg/work.svg',
  DRGroup: '/assets/svg/group.svg',
  Loading: '/assets/svg/loading.svg',
  Partner: '/assets/svg/partner.svg',
 
};

export const iconMap: { [key: string]: string } = {
  AdminGroup: 'AdminGroup',
  Admingroup: 'Admingroup',
  Organization: 'Organization',
  Spacegroup: 'Spacegroup',
  Metergroup: 'Metergroup',
  Site: 'Site',
  Meter: 'Meter',
  Operator: 'Operator',
  Program: 'Program',
  Product: 'Product',
  Portfolio: 'Portfolio',
  DRGroup: 'DRGroup',
  Loading: 'Loading',
  Partner: 'Partner',
};
